import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_URL;

export const createComplementaryUnit = async (complementaryUnit) => {
    try {
        const response = await axiosInstance.put(`${API_URL}/complementary-unit`, complementaryUnit);
        return response;
    } catch (error) {
        throw new Error(error.message);
    }
};

export const getComplementaryUnitById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/complementary-unit/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
};

export const updateComplementaryUnit = async (unitData) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/complementary-unit`, unitData);
      return response;
    } catch (error) {
      console.error("Error en updateComplementaryUnit:", error);
      throw new Error(error.response?.data?.message || error.message);
    }
  };

export const deleteComplementaryUnit = async (id) => {
    try {
        const response = await axiosInstance.delete(`${API_URL}/complementary-unit/${id}`);
        return response;
    } catch (error) {
        throw new Error(error.message);
    }
};

